import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Loading from "../Loading/Loading";

export default function BackdropSpinner({ open }: { open: boolean }) {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <Loading />
      </Backdrop>
    </div>
  );
}
